export const sim6DOFDefaultData = {
  name: "",
  version_name: "",
  note: "",
  type: "",
  series: [
    {
      parameter_path: [],
      aerodynamic_coefficients_path: [],
    },
  ],
  input_data: {
    main: {
      simulation_time: {
        value: null,
        __comment: "input simulation time",
      },
    },
    vehicle: {
      vehicle_length: {
        value: null,
        unit: "m",
        __comment: "Length of the rocket",
      },
      vehicle_radius: {
        value: null,
        unit: "m",
        __comment: "Radius of the rocket",
      },
      dry_mass: {
        value: null,
        unit: "kg",
        __comment: "Dry mass of the rocket",
      },
      propellant_mass: {
        value: null,
        unit: "kg",
        __comment: "Propellant mass of the rocket",
      },
      non_propellant_mass: {
        value: null,
        unit: "kg",
        __comment: "Non-functional propellant mass of the rocket",
      },
      engine_mass: {
        value: null,
        unit: "kg",
        __comment: "Engine mass of the rocket",
      },
      center_of_gravity_total_mass: {
        value: null,
        unit: "m",
        __comment: "Center of gravity at total mass position",
      },
      center_of_gravity_dry_mass: {
        value: null,
        unit: "m",
        __comment: "Center of gravity at dry mass position",
      },
      center_of_gravity_tank: {
        value: null,
        unit: "m",
        __comment: "Center of gravity of tank",
      },
      center_of_pressure: {
        value: null,
        unit: "m",
        __comment: "Aerodynamic center",
      },
      inertia_total_mass: {
        value: null,
        unit: "kgm^2",
        __comment: "Moment of inertia at total mass",
      },
      inertia_dry_mass: {
        value: null,
        unit: "kgm^2",
        __comment: "Moment of inertia at dry mass",
      },
      gimbal_to_thrust_distance: {
        value: null,
        unit: "m",
        __comment: "Distance from gimbal pivot to thrust application point",
      },
    },
    environment: {
      wind_speed: {
        value: null,
        unit: "m/s",
        __comment: "wind speed at initial altitude",
      },
      wind_direction: {
        value: null,
        unit: "deg",
        __comment: "wind direction at initial altitude",
      },
      air_density: {
        value: null,
        unit: "kg/m3",
        __comment: "air density at the same altitude as SPA",
      },
      gravity: {
        value: null,
        unit: "m/s2",
        __comment: "acceleration of gravity at the same altitude as SPA",
      },
      atmospheric_pressure: {
        value: null,
        unit: "Pa",
        __comment: "atmospheric pressure at the same altitude as SPA",
      },
    },
    initial_condition: {
      initial_model: {
        value: 0,
        __comment: "0: Start from ascent; 1: Start from descent",
      },
      initial_position: {
        value: null,
        unit: "m",
        __comment: "Initial position in inertial frame [Altitude East North]",
      },
      initial_velocity: {
        value: null,
        unit: "m/s",
        __comment: "Initial velocity in body axis frame [ub vb wb]",
      },
      initial_angular_velocity: {
        value: null,
        unit: "deg/s",
        __comment: "Initial angular velocity [p q r]",
      },
      initial_euler: {
        value: null,
        unit: "deg",
        __comment: "Initial attitude angles [roll pitch yaw]",
      },
      initial_engine_state: {
        value: null,
        unit: "",
        __comment: "Initial engine state (0.55-1)",
      },
      emergency_stop_time: {
        value: null,
        unit: "s",
        __comment: "Time of issuing emergency stop signal",
      },
      emergency_landing_time: {
        value: null,
        unit: "s",
        __comment: "Time of issuing emergency landing signal",
      },
    },
    target: {
      ascent_position: {
        value: null,
        unit: "m",
        __comment: "target ascent position [Altitude East North]",
      },
      ascent_velocity: {
        value: null,
        unit: "m/s",
        __comment: "target ascent velocity [u v w]",
      },
      geodetic_lla0: {
        value: null,
        unit: "m",
        __comment: "landing geodetic coordinate [Latitude Longitude Altitude]",
      },
      geodetic_llaf: {
        value: null,
        unit: "m",
        __comment: "landing geodetic coordinate [Latitude Longitude Altitude]",
      },
      landing_velocity: {
        value: null,
        unit: "m/s",
        __comment: "target landing velocity [u v w]",
      },
    },
  },
};
